import Vue from 'vue'
import Router from 'vue-router'
import mapComponent from '@/components/mapComponent'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mapComponent',
      component: mapComponent
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js